<template>
  <div>
    <b-breadcrumb :items="items" style="background-color: transparent"></b-breadcrumb>

    <b-container>
      <b-row>
        <b-col sm="12" md="8" class="padding">
          <h4>
            Tempo em prova
            <small>(segundos)</small>
          </h4>
          <chart />
        </b-col>

        <b-col sm="12" md="4" class="padding">
          <h4>Provas feitas</h4>
          <round-chart />
        </b-col>
      </b-row>

      <b-row style="padding-top: 20px">
        <b-col cols="12" class="padding">
          <h4>Provas - <small>aproveitamento</small></h4>

          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="provas"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
          ></b-table>
        </b-col>
        <b-col cols="12">
          <div id="table-legend">
            <div style="display:inline-flex">
              <span
                style="margin: 7px 4px 0 0; height: 10px; width: 10px; background-color: #c3e6cb"
              ></span>Aprovado
              <span
                style="margin: 7px 4px 0 4px; height: 10px; width: 10px; background-color: #ffeeba"
              ></span>Média
              <span
                style="margin: 7px 4px 0 4px; height: 10px; width: 10px; background-color: #f5c6cb"
              ></span>Reprovado
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Chart from "../charts/Chart.vue";
import RoundChart from "../charts/ChartRound.vue";

export default {
  components: {
    Chart,
    RoundChart
  },
  data() {
    return {
      fields: ["Modulo", "Prova", "Score"],
      provas: [
        {
          Modulo: "Nefrite Lúpica",
          Prova: "Prova 02",
          Score: "65%",
          _rowVariant: "warning"
        },
        {
          Modulo: "Nefrite Lúpica",
          Prova: "Prova 01",
          Score: "100%",
          _rowVariant: "success"
        },
        {
          Modulo: "Nefrite Lúpica",
          Prova: "Prova 04",
          Score: "30%",
          _rowVariant: "danger"
        },
        {
          Modulo: "Nefrite Lúpica",
          Prova: "Prova 04",
          Score: "80%",
          _rowVariant: "success"
        }
      ],items: [
          {
            text: 'Home',
            to: { name: 'categories' }
          },
          {
            text: 'Relatório',
            to: { name: 'dashboard' }
          }
        ],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: true,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: "light",
      tableVariant: "",
      noCollapse: false
    };
  }
};
</script>

<style scoped>
a {
  color: #2c3e50;
}
</style>